import { Component, OnInit } from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {DataManagementService} from "../data-management/data-management.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-video-emergency',
  templateUrl: './video-emergency.component.html',
  styleUrls: ['./video-emergency.component.scss'],
})
export class VideoEmergencyComponent {

  sanitizedUrl: SafeResourceUrl;

  private readonly url: string = 'https://dev.rimtrack.com/if3/uploads/';

  constructor(private sanitizer: DomSanitizer,
              public dataManagementService : DataManagementService,
              public router : Router,
              ) {
    // Sanitize the URL for safe usage in an iframe
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url+this.dataManagementService.selectedVehicule.device.streamId);
  }

  close() {
    this.router.navigate(['client']);
  }
  chooseVehicule(vehicule:any) {
    this.dataManagementService.selectedVehicule = vehicule;
    this.sanitizeUrl();
  }

  chooseGroup(group:any) {
    this.dataManagementService.selectedGroup = group;
    if (this.dataManagementService.selectedGroup!.vehicules.length > 0 && this.dataManagementService.selectedGroup) {
      this.dataManagementService.selectedVehicule = this.dataManagementService.selectedGroup.vehicules[0];
    }
  }

  sanitizeUrl() {
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url+this.dataManagementService.selectedVehicule.device.streamId);
  }
}
